module.exports = __webpack_public_path__ + "img/sec_left_white.d44f2562.svg";